import React from "react";
import { Link } from "react-router-dom";

const LoginHead = () => {
  return (
    <div className="breadcrumbs d-flex align-items-center">
      <div
        className="container position-relative d-flex flex-column align-items-center"
        data-aos="fade"
      >
        <h2>Login</h2>
        <ol>
          <li>
            <Link to={"/"}>Home</Link>
          </li>
          <li>Login</li>
        </ol>
      </div>
    </div>
  );
};

export default LoginHead;
